<template>
  <div id="edit-employee">
    <h4 class="page_heading">Edit LinkInfo</h4>

    <div class="row">
      <form @submit.prevent="updateEmployee" class="col s12">
        <div class="input-field col s6">
          <md-field>
            <label>Link Id</label>
            <input type="text" disabled v-model="link_id" required />
          </md-field>
        </div>
        <div class="row">
          <div class="input-field col s6">
            <md-field>
              <label>LinkO #ID</label>
              <input type="text" v-model="linko_id" required />
            </md-field>
          </div>
        </div>
        <div class="row">
          <div class="input-field col s12">
            <md-field>
              <label>Link Name</label>
              <input type="text" v-model="link_name" required />
            </md-field>
          </div>
        </div>
        <div class="row">
          <div class="input-field col s12">
            <md-field>
              <label>Link Url</label>
              <input type="text" v-model="link_url" required />
            </md-field>
          </div>
        </div>
        <div class="row">
          <div class="input-field col s12">
            <md-field>
              <label>Link Type</label>
              <input type="text" v-model="link_type" required />
            </md-field>
          </div>

          <div class="input-field col s12">
            <md-field>
              <label>Link Description</label>
              <textarea v-model="link_desc" required></textarea>
            </md-field>
          </div>

          <div class="input-field col s12">
            <md-field>
              <label>Link Category</label>
              <input type="text" v-model="link_category" required />
            </md-field>
          </div>
        </div>

        <router-link :to="{name:'view-linkinfo',params:{link_id:link_id}}" class="btn grey">Back</router-link>

        <button type="submit" @submit.prevent="updateEmployee" class="btn green">Submit</button>
      </form>
    </div>
  </div>
</template>
<script>
import db from "./firebaseInit";
export default {
  name: "edit-employee",

  data() {
    return {
      linko_id: null,
      link_id: null,
      link_name: null,
      link_url: null,
      link_type: null,
      link_desc: null,
      link_category: null
    };
  },
  beforeRouteEnter(to, from, next) {
    db.collection("linkinfo")
      .where("link_id", "==", to.params.link_id)
      .get()
      .then(querySnapshot => {
        querySnapshot.empty === true
          ? next({
              path: "/",
              query: {
                redirect: to.fullpath
              }
            })
          : "";
        querySnapshot.forEach(doc => {
          next(vm => {
            (vm.linko_id = doc.data().linko_id),
              (vm.link_id = doc.data().link_id),
              (vm.link_name = doc.data().link_name),
              (vm.link_url = doc.data().link_url),
              (vm.link_type = doc.data().link_type),
              (vm.link_desc = doc.data().link_desc),
              (vm.link_category = doc.data().link_category);
          });
        });
      });
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    fetchData() {
      db.collection("linkinfo")
        .where("link_id", "==", this.$router.params.link_id)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            (this.link_id = doc.data().link_id),
              (this.link_name = doc.data().link_name),
              (this.link_url = doc.data().link_url),
              (this.link_type = doc.data().link_type);

            this.link_desc = doc.data().link_desc;
            this.link_category = doc.data().link_category;
          });
        });
    },
    updateEmployee() {
      db.collection("linkinfo")
        .where("link_id", "==", this.$route.params.link_id)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            doc.ref
              .update({
                linko_id: this.linko_id,
                link_name: this.link_name,
                link_url: this.link_url,
                link_type: this.link_type,
                link_desc: this.link_desc,
                link_category: this.link_category
              })
              .then(() => {
                this.$router.push({
                  name: "view-linkinfo",
                  params: {
                    link_id: this.link_id
                  }
                });
              });
          });
        });
    }
  }
};
</script>

<style>
textarea {
  padding: 10px;
  height: 100px;
  border-left: 0px;
  border-right: 0px;
}
</style>




// WEBPACK FOOTER //
// src/components/LinkEditInfo.vue